export const EMAIL_REGEX =
  /^(([^<>()[\]?.,;:\s@"]+(\.[^<>()[\]?.,;:\s@"]+)*)|(".+"))@(([^<>()[\]?.,;:\s@"]+\.)+[^<>()[\]?.,;:\s@"]{2,})$/i;
export const NUMBER_REGEX = /^[0-9]*$/;
export const SMALL_DECIMAL_NUMBER_REGEX = /^[0-9]{2}([,.][0-9]{1,2})?$/;
export const DECIMAL_NUMBER_REGEX = /^-?\d+(\.\d{1,5})?$/;
export const NUMBER_REGEX_NO_ZERO_HEADER = /^[1-9][0-9]*$/;
export const POSITIVE_DECIMAL_NUMBER_REGEX = /^[0-9]*([,.][0-9]{1,5})?$/;
export const DAY_REGEX = /^\d{4}-\d{2}-\d{2}$/;
